<template>
  <div
    v-if="geoType === 'precinct' && !geoSelection"
    class="topline-bottom-info"
    :style="[{ height: breakpoint.xsOnly ? '60px' : '320px' }]">
    <span :style="!breakpoint.smAndDown ? 'padding-bottom: 80px;' : ''"
      >Select a precinct to view top line results for that region</span
    >
  </div>
</template>

<script>
const props = ["geoType", "geoSelection"];

const computed = {
  breakpoint() {
    return this.$store.getters.breakpoint(this.results.race_id);
  },
};

export default {
  props,
  computed,
};
</script>
